module.exports = typeof window !== "undefined" ? require("./main") : null
